import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config.json";

const PrivacyPolicy = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/privacy_policy/`)
      .then((res) => {
        setLoading(false);
        setPosts(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        setError("Failed to load privacy policy");
        console.error(err);
      });
  }, []);

  return (
    <section className="section-p">
      <div className="page-width">
        <div className="privacy">
          <h1 className="legal-title text-jost-sb-50-wt">PRIVACY POLICY</h1>
          <div className="legal__box">
            {loading ? (
              <h1>Loading ....</h1>
            ) : error ? (
              <h1>{error}</h1>
            ) : (
              posts.map((post) => (
                <div key={post.id}>
                  <h2 className="legal__box-heading text-jost-sb-22-lg">
                    {post.title}
                  </h2>
                  <div
                    className="legal__box-para text-ops-rg-16"
                    dangerouslySetInnerHTML={{ __html: post.description }}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
